import ValidationError from '../errors/ValidationError'

const Validator = {
  isNotEmpty(name, value) {
    return !!value
  },

  notEmpty(name, value, message) {
    if (!Validator.isNotEmpty(name, value)) {
      if (!message) message = `expected ${name} to be provided`
      Validator.raise(name, undefined, message)
    }
  },

  isOneOf(name, value, values) {
    return values.includes(value)
  },

  oneOf(name, value, values, message) {
    if (!Validator.isOneOf(name, value, values)) {
      if (!message) message = `expected ${value} to be one of (${values.join(', ')})`
      Validator.raise(name, undefined, message)
    }
  },

  raise(name, code='invalid', message) {
    throw new ValidationError(name, code, message)
  },
}

export default Validator
